import React from 'react';

import PropTypes from 'prop-types';

export const mobile = ({ fillColor }) => (
    <svg
        viewBox='0 0 16 24'
        version='1.1'
        xmlns='http://www.w3.org/2000/svg'
        xmlnsXlink='http://www.w3.org/1999/xlink'
    >
        <defs>
            <path
                d='M7.33668342,19.1758794 L8.54271357,19.1758794 L8.54271357,20.3819095 L7.33668342,20.3819095 L7.33668342,19.1758794 Z M12.040201,0 L3.83919598,0 C1.78894472,0 0.221105528,1.5678392 0.221105528,3.61809045 L0.221105528,20.3819095 C0.221105528,22.4321608 1.78894472,24 3.83919598,24 L12.160804,24 C14.2110553,24 15.7788945,22.4321608 15.7788945,20.3819095 L15.7788945,3.61809045 C15.6582915,1.5678392 14.0904523,0 12.040201,0 Z M3.83919598,2.4120603 L12.160804,2.4120603 C12.7638191,2.4120603 13.2462312,2.89447236 13.3668342,3.37688442 C13.3668342,4.30711112 13.3668342,4.77222446 13.3668342,4.77222446 C13.3668342,4.77222446 2.63316583,4.77222446 2.63316583,4.77222446 C2.63316583,4.77222446 2.63316583,4.30711112 2.63316583,3.37688442 C2.75376884,2.77386935 3.2361809,2.4120603 3.83919598,2.4120603 Z M13.2462312,6.99497487 L13.2462312,15.678392 L2.63316583,15.678392 L2.63316583,6.99497487 L13.2462312,6.99497487 Z M12.040201,21.4673367 L3.83919598,21.4673367 C3.11557789,21.4673367 2.63316583,20.9849246 2.63316583,20.2613065 L2.63316583,17.9698492 L13.3668342,17.9698492 L13.3668342,20.2613065 C13.2462312,20.9849246 12.7638191,21.4673367 12.040201,21.4673367 Z'
                id='path-mobile'
            />
        </defs>
        <g
            id='Symbols'
            stroke='none'
            strokeWidth='1'
            fill='none'
            fillRule='evenodd'
        >
            <mask id='mask-2' fill='white'>
                <use xlinkHref='#path-mobile' />
            </mask>
            <use
                id='Mask'
                fill={fillColor}
                fillRule='nonzero'
                xlinkHref='#path-mobile'
            />
        </g>
    </svg>
);

mobile.propTypes = {
    fillColor: PropTypes.string.isRequired
};

export default mobile;
